import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FlaskConical } from 'lucide-react';
import { Header } from './Header';
import { VisitorOnly } from '@/hooks/useIsVisitor';
import { Footer } from './Footer';

export const DemoBar = () => (
  <div className="border-b border-white/5 bg-[#05060a]" data-testid="demo-bar">
    <div className="container-x flex items-center justify-center gap-2 py-1.5 text-center text-[11px] text-muted-foreground">
      <FlaskConical className="h-3 w-3 shrink-0 text-primary" />
      <span>Protótipo de demonstração · dados fictícios · alterações ficam salvas apenas neste navegador</span>
    </div>
  </div>
);

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
};

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-[var(--void)]">
      <a href="#conteudo" className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-md focus:bg-primary focus:px-3 focus:py-2 focus:text-primary-foreground">Pular para o conteúdo</a>
      <VisitorOnly><DemoBar /></VisitorOnly>
      <Header />
      <main id="conteudo">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
